import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrintLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";

import PN from "persian-number";


const PrintBuyOrderIndex = () => {

    //#region Const
    const navigate = useNavigate();
    const toaster = rsuite.useToaster();
    const [ItemList, setItemList] = useState([]);
    const [Code, setCode] = useState("");

    const [DiscountPercent, setDiscountPercent] = useState(0);
    const [DiscountPrice, setDiscountPrice] = useState(0);
    const [SumItemPrice, setSumItemPrice] = useState(0); // محموع قیمت خالص آیتم ها
    const [HeaderDiscount, setHeaderDiscount] = useState(0); // مجموع کل تخفیف
    const [HeaderTax, setHeaderTax] = useState(0); // مالیات کل

    const [SumTotalPrice, setSumTotalPrice] = useState(0);  // قیمت کل با درنظر گرفتن مالیات و تخفیف هر آیتم
    const [HeaderPrice, setHeaderPrice] = useState(0); // قیمت کل فاکتور
    const [FreightPrice, setFreightPrice] = useState(0);
    const [InsertDate, setInsertDate] = useState("");
    const [Supplier, setSupplier] = useState("");

    //#region Methods


    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/BuyOrder/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': localStorage.getItem("BuyOrderHeaderId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setInsertDate(result.insertDate)
                    setHeaderPrice(result.price);
                    setCode(result.code);
                    setSupplier(result.supplierFullName + '(' + result.supplierMobile + ')')
                    setDiscountPercent(result.discountPercent)
                    setDiscountPrice(result.discountPrice)
                    setFreightPrice(result.freightPrice)
                    GetByHeaderId(result.freightPrice, result.discountPrice);

                })
        )
    }

    const GetByHeaderId = (FreightPrice, DiscountPrice) => {
        trackPromise(
            fetch(General.ApiRoute() + '/BuyOrder/GetByHeaderId', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': localStorage.getItem("BuyOrderHeaderId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = [];

                    if (result.length > 0) {
                        setHeaderTax(result.map(o => o.tax).reduce((a, b) => a + b));
                        setHeaderDiscount(result.map(o => o.discountPrice).reduce((a, b) => a + b) + DiscountPrice * 1);
                        setSumItemPrice(result.map(o => (o.price * o.count) * 1).reduce((a, b) => a + b));
                        setSumTotalPrice(result.map(o => o.totalPrice).reduce((a, b) => a + b));
                        setHeaderPrice(result.map(o => o.totalPrice).reduce((a, b) => a + b) * 1 + FreightPrice * 1 - DiscountPrice * 1);
                        for (var i = 0; i < result.length; i++) {
                            tmp.push({
                                row: i + 1,
                                Price: PN.sliceNumber(result[i].price),
                                Tax: PN.sliceNumber(result[i].tax),
                                TotalPrice: PN.sliceNumber(result[i].totalPrice),
                                DiscountPrice: PN.sliceNumber(result[i].discountPrice),
                                DiscountPercent: PN.sliceNumber(result[i].discountPercent),
                                Count: result[i].count,
                                Product: result[i].product,
                                ProductIdentityNo: result[i].productIdentityNo,
                                InsertDateTime: result[i].insertDate + " " + result[i].insertTime,

                            })
                        }
                        setItemList(tmp)
                    }

                })
        )
    }



    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 16);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetById();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    useEffect(() => {
        CheckPermission();
        document.title = "چاپ فاکتور خرید";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion







    return (

        <Layout title=" فاکتور خرید">
            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white  ">

                    <rsuite.Row className='p-1'>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <b>شماره فاکتور :</b>
                            {Code}
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <b>تامین کننده :</b> {Supplier}
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <b> تاریخ : </b> {InsertDate}


                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <b>هزینه باربری (ریال) :</b> {PN.sliceNumber(FreightPrice)}
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='me-2 Font10 ' as='sub'>{FreightPrice != "0" ? <>{PN.convert(FreightPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <b>درصد تخفیف :</b> {DiscountPercent} %
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <b> تخفیف فاکتور (ریال) :</b> {PN.sliceNumber(DiscountPrice)}
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='me-2 Font10 ' as='sub'>{DiscountPrice != "0" ? <>{PN.convert(DiscountPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1">

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                            <rsuite.Table height={ItemList.length==1 ? 100 : ItemList.length==2 ? 160 :ItemList.length * 75} data={ItemList} >
                                <rsuite.Table.Column width={50} align="center"  >

                                    <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='row' />
                                </rsuite.Table.Column>


                                <rsuite.Table.Column flexGrow={1} resizable>
                                    <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='Product' />
                                </rsuite.Table.Column>


                                <rsuite.Table.Column width={100} >
                                    <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='Count' />
                                </rsuite.Table.Column>


                                <rsuite.Table.Column fullText width={120}>
                                    <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='Price' />
                                </rsuite.Table.Column>

                                {/* <rsuite.Table.Column fullText width={120} >
                                    <rsuite.Table.HeaderCell>تخفیف (%)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='DiscountPercent' />
                                </rsuite.Table.Column> */}

                                <rsuite.Table.Column fullText width={120} >
                                    <rsuite.Table.HeaderCell>تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='DiscountPrice' />
                                </rsuite.Table.Column>


                                <rsuite.Table.Column fullText width={120} >
                                    <rsuite.Table.HeaderCell>مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='Tax' />
                                </rsuite.Table.Column>


                                {/* <rsuite.Table.Column fullText flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت تمام شده هر واحد در کاردکس (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input disabled value={PN.sliceNumber(rowData.FinalPrice)} />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.FinalPrice != "0" ? <>{PN.convert(rowData.FinalPrice)} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.FinalPrice)}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column> */}

                                <rsuite.Table.Column fullText width={120} >
                                    <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='TotalPrice' />
                                </rsuite.Table.Column>




                            </rsuite.Table>



                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1 Font13 '>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>قیمت آیتم ها : </b> {PN.sliceNumber(SumItemPrice)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='me-2 Font10' as='sub'>{HeaderDiscount != "0" ? <>{PN.convert(SumItemPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>مالیات کل : </b> {PN.sliceNumber(HeaderTax)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='me-2 Font10' as='sub'>{HeaderTax != "0" ? <>{PN.convert(HeaderTax)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>تخفیف کل : </b> {PN.sliceNumber(HeaderDiscount)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='me-2 Font10' as='sub'>{HeaderDiscount != "0" ? <>{PN.convert(HeaderDiscount)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                            <b>مبلغ فاکتور : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='me-2 Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >




        </Layout >


    )
}

export default PrintBuyOrderIndex;